import React, { Fragment } from 'react'
import successImage from './images/success.svg'

const headers = {
  en: 'Your coupon has been activated!',
  pt: 'Seu cupom foi ativado!',
  es: 'Tu cupón ha sido activado.',
  de: 'Dein Gutschein wurde aktiviert!',
};

const messages = {
  en: 'In order to proceed, use the Fortunica mobile app.',
  pt: 'Para continuar, utilize o app fortunica no celular.',
  es: 'Para proceder, utiliza la aplicación móvil de fortunica.',
  de: 'Um fortzufahren, benutze die fortunica Mobile App.',
};

export default ({locale}) => {
    return (
        <Fragment>
            <img className='activation-image' src={successImage} alt=''/>
            <div className='message-title'>{headers[locale] || headers.en}</div>
            <div className='message'>{messages[locale] || messages.en}</div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/coupon/success.js